import type { LinkProps } from '@chakra-ui/next-js';
import { MenuItem as CkMenuItem, type MenuItemProps } from '@chakra-ui/react';

const MenuItem: React.FC<MenuItemProps & Partial<LinkProps>> = ({
  children,
  ...props
}) => {
  return (
    <CkMenuItem
      _hover={{ backgroundColor: 'secondary.100' }}
      _active={{ backgroundColor: 'secondary.100' }}
      _focus={{ backgroundColor: 'secondary.50' }}
      {...props}
    >
      {children}
    </CkMenuItem>
  );
};

export default MenuItem;
